import React from "react"
import moment from "moment"

import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import { push, goBack } from "react-router-redux"
import "./Trips.css"
import Card from "../core/Card"
import SideNav from "../layout/SideNav"
import {
  MapIcon,
  Icon,
  TripsIcon,
  PaperclipIcon,
  NoteIcon,
  BackIcon,
  BriefcaseIcon,
  VehicleIcon,
  DotIcon,
  ForwardIcon,
  MergeIcon
} from "../core/icons"
import {
  Row,
  Col,
  Button,
  Select,
  DatePicker,
  Icon as AIcon,
  Tag,
  Tooltip,
  Popover,
  Checkbox,
  Dropdown,
  InputNumber,
  Tabs,
  Input,
  message,
  Popconfirm
} from "antd"
import { connect } from "react-redux"
import {
  toggleTrip,
  loadMore,
  getTrips,
  updateRange,
  selectFilter,
  clearFilters,
  selectPlaceFilter,
  updateTrip,
  updateNote,
  deleteTrip
} from "./actions"
import Summary from "./Summary"
import { withPreviousDate, getPurposes } from "./reducer"
import Line from "../core/Line"
import numeral from "numeral"
import styled, { keyframes, ThemeProvider } from "styled-components"
import MapCard, { Map } from "./MapCard"
import Location from "./Location"
import { VehiclePicker } from "./VehiclePicker"
import { Purpose } from "./Purpose"
import { Spin, Switch, Alert } from "antd"

const Option = Select.Option
const TabPane = Tabs.TabPane
const { TextArea } = Input
const mapHeight = 240
const HoverActions = styled.div`
  .HoverActions {
    position: absolute;
    opacity: 0;
    right: 0px;
    z-index: 999;
    margin-top: -10px;
  }
  &:hover {
    .HoverActions {
      opacity: 1;
      animation-duration: 0.5s;
      animation-name: slideIn;
    }

    @keyframes slideIn {
      from {
        opacity: 0;
        transform: translateX(800px);
      }

      to {
        opacity: 1;
        transform: translateX(0px);
      }
    }
  }
`
const TabsHover = styled.div`
  .ant-tabs {
    border-radius: 2px;
    box-shadow: 0px 0px 11px 0 rgba(4,25,52,0.14);
    &:hover {
      .ant-tabs-bar {
        opacity: 1.0;
      }
    }
    .ant-tabs-bar {
      .ant-tabs-ink-bar {
        background-color: rgb(49, 181, 159);
      }
      ${props => props.hasHover && `opacity: 0;`}
      transition: all 500ms ease-in-out;
      ${"" /* margin-top: 0; */}
      margin-top:-48px;
      .ant-tabs-nav-container {
        background: white;
        display: flex;
        justify-content: center;
      }
    }

    .ant-tabs-tabpane {
      ${"" /* overflow: scroll; */}
      ${props => (props.hasHover ? `overflow: hidden;` : `overflow: scroll;`)}
      height: ${mapHeight}px;
      textarea {
        resize: none;
        font-size: 18px;
        border: none;
        padding: 20px 20px 0 20px;
        &:focus {
          box-shadow: none;
        }
      }
    }
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const NotesSuccess = styled(Alert)`
  position: absolute;
  top: 20px;
  right: 20px;
  animation-duration: 1s;
  animation-iteration-count: 2;
  animation-direction: alternate;
  animation-name: ${fadeIn};
  opacity: ${props => (props.hasSaved ? 1 : 0)};
`

function debounce(a, b, c) {
  var d, e
  return function() {
    function h() {
      ;(d = null), c || (e = a.apply(f, g))
    }
    var f = this,
      g = arguments
    return (
      clearTimeout(d), (d = setTimeout(h, b)), c && !d && (e = a.apply(f, g)), e
    )
  }
}

class NotesArea extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value || "",
      hasSaved: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  // https://jsfiddle.net/pwatsonwailes/kp04015o/
  debounceVal = debounce(() => {
    // this.setState({value, hasSaved:false})
    this.handleSubmit(this.state.value)
  }, 1000)

  handleChange(e) {
    this.setState({
      value: e.target.value,
      hasSaved: false
    })

    return this.debounceVal()
  }

  handleSubmit() {
    // if different than this.props.value
    const { value } = this.state
    if (value != this.props.value)
      this.props.onUpdate(value).then(() => {
        this.setState({ hasSaved: true })
        setTimeout(() => {
          this.setState({ hasSaved: false })
        }, 2000)
      })
  }

  render() {
    return (
      <div>
        <TextArea
          autoFocus
          defaultValue={this.props.value}
          autosize={{ minRows: 6, maxRows: 6 }}
          placeholder="Enter notes here..."
          onChange={this.handleChange}
        />

        {this.state.hasSaved && (
          <NotesSuccess
            message="Saved!"
            type="success"
            showIcon
            hasSaved={this.state.hasSaved}
          />
        )}
      </div>
    )
  }
}

class TabsArea extends React.Component {
  state = {
    tab: "1" //keeping track of active tab for <TabsHover/> hasHover prop
  }
  changeTab(e) {
    this.setState({ tab: e })
  }
  render() {
    const { mapBoxUrl } = this.props
    var re = /auto\/(\d{3}x\d{3})/
    const replacer = `auto/400x${mapHeight}`
    const mapBoxUrlCropped = mapBoxUrl && mapBoxUrl.replace(re, replacer)
    return (
      <TabsHover hasHover={this.state.tab == "1"}>
        <Tabs
          tabPosition="bottom"
          onChange={this.changeTab.bind(this)}
          defaultActiveKey={mapBoxUrl ? "1" : "2"}
        >
          <TabPane tab={<MapIcon />} key="1">
            {mapBoxUrl ? (
              <div
                onClick={this.props.onMapClick}
                style={{
                  width: "100%",
                  height: mapHeight,
                  background: `no-repeat center/100% url("${mapBoxUrlCropped}")`,
                  backgroundSize: "cover",
                  cursor: "zoom-in"
                }}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%"
                }}
              >
                Map not available for this trip
              </div>
            )}
          </TabPane>
          <TabPane
            tab={
              <span>
                <Tooltip title={<span>{this.props.trip.notes}</span>}>
                  <NoteIcon isChecked={this.props.trip.notes} />
                </Tooltip>
              </span>
            }
            key="2"
          >
            <NotesArea
              value={this.props.trip.notes}
              onUpdate={this.props.onNoteUpdate}
            />
          </TabPane>
          <TabPane
            tab={
              <Tooltip
                title={
                  <span>
                    {this.props.trip.vehicle_id
                      ? "View / change this trip's vehicle"
                      : "Select a vehicle for this trip"}
                  </span>
                }
              >
                <VehicleIcon isChecked={this.props.trip.vehicle_id} />
              </Tooltip>
            }
            key="3"
          >
            <VehiclePicker
              onVehicleSelect={this.props.onVehicleSelect}
              vehicle_id={this.props.trip.vehicle_id}
            />
          </TabPane>
        </Tabs>
      </TabsHover>
    )
  }
}

const mapStateToProps = ({ trips, account, models }, ownProps) => ({
  ...ownProps.trip,
  isChecked: trips.filter_params.token_ids.includes(ownProps.trip.token_id),
  isAnyTripChecked: trips.filter_params.token_ids.length > 0,
  checkboxesVisible: trips.checkboxesVisible,
  purposes: getPurposes({ models }),
  kms_enabled: models.user.kms_enabled
})

const Deduction = styled.div`
  color: rgb(49, 181, 159);
  padding-left: 20px;
  ${props =>
    props.isUnclassified &&
    `
    color: rgb(150, 162, 194);
  `};
`

const mapDispatchToProps = (dispatch, ownProps) => {
  const tokenId = ownProps.trip.token_id
  return {
    toggleTrip: token_id => dispatch(toggleTrip(token_id)),
    updateTrip: (token_id, value) => dispatch(updateTrip(token_id, value)),
    onClickTripLine: () => dispatch(push(`/trips/${tokenId}`)),
    updateNote: (prevNotes, notes, token_id) =>
      dispatch(updateNote(prevNotes, notes, token_id)),
    deleteTrip: () =>
      dispatch(deleteTrip(tokenId)).then(() =>
        message.success("Deleted trip successfully.", 10)
      )
  }
}

const TripRow = styled(Row)`
  overflow: hidden;
  padding: 30px 10px;
`

// TODO handle locations (array), auto_detected (bool), started_at, started_at_coordinate, income_source, start_place
const TripLineExpanded = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ({
    checkboxesVisible,
    parent_trip,
    notes,
    photo,
    start_place,
    end_place,
    updateTrip,
    purposes,
    places,
    isChecked,
    isAnyTripChecked,
    income_source,
    toggleTrip,
    started_at,
    ended_at,
    prevTrip,
    isSameDate,
    token_id,
    vehicle_id,
    miles,
    kms,
    kms_enabled,
    purpose,
    from,
    to,
    savings,
    locations,
    date_formatted,
    onClickTripLine,
    favorite_trip,
    deduction,
    mapbox_url,
    started_at_coordinate,
    ended_at_coordinate,
    style,
    key,
    updateNote,
    from_city,
    from_street,
    from_country,
    from_state,
    to_city,
    to_street,
    to_country,
    to_state,
    deleteTrip
  }) => (
    <HoverActions>
      <div className="HoverActions">
        <Button.Group>
          <Button icon="edit" onClick={onClickTripLine}>
            Edit Trip
          </Button>
          {/* <Button icon="environment-o" onClick={onClickTripLine}>
              Save as Favorite Trip
            </Button> */}
          <Tooltip title={<span>Delete</span>}>
            <Popconfirm
              title="Are you sure?"
              placement="bottom"
              onConfirm={deleteTrip}
              okText="Yes"
              cancelText="No"
            >
              <Button type="danger" icon="delete" />
            </Popconfirm>
          </Tooltip>
        </Button.Group>
      </div>
      <TripRow gutter={20} justify="space-around" type="flex">
        <Col xs={24} md={13}>
          <Row type="flex" style={{ fontSize: 20 }}>
            <Col span={15}>
              <Purpose
                {...{
                  token_id,
                  isChecked,
                  checkboxesVisible,
                  purpose,
                  income_source,
                  updateTrip,
                  purposes,
                  toggleTrip
                }}
              />
            </Col>
            <Col span={9}>
              <Row type="flex" justify="end" style={{ fontWeight: 600 }}>
                <div>
                  {numeral(kms_enabled ? kms : miles).format("0,0.0")}{" "}
                  {kms_enabled ? "km" : "mi"}
                </div>
                {deduction != 0 && (
                  <Deduction isZero={deduction == 0} isUnclassified={!purpose}>
                    ${-deduction}
                  </Deduction>
                )}
              </Row>
            </Col>
          </Row>
          {photo || favorite_trip || parent_trip ? null : (
            <div style={{ height: 28 }} />
          )}
          <br />
          <Location
            from={from}
            place={start_place}
            time={started_at}
            // addr={from}
            data={{
              latLng: started_at_coordinate,
              city: from_city,
              street: from_street,
              state: from_state,
              country: from_country,
              trip_token_id: token_id
            }}
          />
          <br />
          <Location
            to={to}
            place={end_place}
            time={ended_at}
            // addr={to}
            data={{
              latLng: ended_at_coordinate,
              city: to_city,
              street: to_street,
              state: to_state,
              country: to_country,
              trip_token_id: token_id
            }}
          />

          {photo || favorite_trip || parent_trip ? (
            <Row
              type="flex"
              justify="start"
              align="middle"
              style={{ "padding-top": 23 }}
            >
              {photo && (
                <Tooltip title={<img width="100" src={photo.image_url} />}>
                  <span style={{ paddingRight: 20 }}>
                    <PaperclipIcon />
                  </span>
                </Tooltip>
              )}
              {favorite_trip && (
                <Tooltip
                  title={
                    <div>
                      Favorite Trip Detected
                      <div>
                        Auto classified as {purpose} {income_source}
                      </div>
                    </div>
                  }
                >
                  <span style={{ paddingRight: 20 }}>
                    <TripsIcon />
                  </span>
                </Tooltip>
              )}
              {parent_trip && (
                <Tooltip title={'Trip was merged. "Edit trip" to undo merge.'}>
                  <span style={{ paddingRight: 20 }}>
                    <MergeIcon />
                  </span>
                </Tooltip>
              )}
            </Row>
          ) : null //<div style={{height:32}}/>
          }
        </Col>
        <Col xs={0} md={11} style={{ maxWidth: 400 }}>
          <TabsArea
            mapBoxUrl={mapbox_url}
            trip={{
              locations,
              started_at_coordinate,
              ended_at_coordinate,
              vehicle_id,
              notes
            }}
            onMapClick={onClickTripLine}
            onVehicleSelect={val => updateTrip({ vehicle_id: val, token_id })}
            onNoteUpdate={val =>
              updateTrip({ notes: val, token_id, overrideSuccess: true })
            }
            // onNoteUpdate={(val)=>updateNote({notes: val, token_id})}
          />
        </Col>
      </TripRow>
    </HoverActions>
  )
)

export default TripLineExpanded



// WEBPACK FOOTER //
// ./src/trips/TripLineExpanded.js